export default {
    profileInfo: state => state.profileInfo,
    allOrders: state => state.allOrders,
    allSavedDesigns: state => state.allSavedDesigns,
}